import { useEffect, useState } from 'react';
import Popup from '../../../../../../../components/general/Popup.tsx';
import { Input } from '../../../../../../../components/general/Input.tsx';
import Form from '../../../../../../../components/form-library/index.ts';
import { Subledger, SubledgerFormValues } from './types.ts';

const EMPTY_FORM: SubledgerFormValues = { name: '' };

interface SubledgerModalProps {
    open: boolean;
    subledger: Subledger | null;
    takenNames: string[];
    onSubmit: (values: SubledgerFormValues) => Promise<void>;
    onClose: () => void;
}

export default function SubledgerModal({ open, subledger, takenNames, onSubmit, onClose }: SubledgerModalProps) {
    const [form] = Form.useForm<SubledgerFormValues>();
    const [isSaving, setIsSaving] = useState(false);

    const isEditing = subledger !== null;

    useEffect(() => {
        setIsSaving(false);
        if (!open) {
            return;
        }
        if (subledger) {
            form.setFieldsValue({ name: subledger.name });
        } else {
            form.setFieldsValue({ ...EMPTY_FORM });
        }
    }, [open, subledger, form]);

    const handleFinish = async (values: SubledgerFormValues) => {
        setIsSaving(true);
        try {
            await onSubmit(values);
            form.resetFields();
        } catch {
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Popup
            open={open}
            onClose={onClose}
            onConfirm={() => form.submit()}
            title={isEditing ? 'Subledger bewerken' : 'Nieuwe subledger'}
            confirmButtonDisplayLabel="Opslaan"
            confirmButtonDisabled={isSaving}
            Icon={null}
        >
            <p className="text-sm text-gray-500 mt-1">
                Een subledger is een optioneel label om boekingen van deze klant verder te onderverdelen.
            </p>
            <Form
                form={form}
                className="py-2"
                initialValues={EMPTY_FORM}
                onFinish={(v) => void handleFinish(v)}
            >
                <Form.Item
                    name="name"
                    label="Naam"
                    rules={[
                        { required: true, message: 'Vul een naam in.' },
                        {
                            message: 'Er bestaat al een subledger met deze naam.',
                            validator: (_, value) => {
                                const normalized = typeof value === 'string' ? value.trim().toLowerCase() : '';
                                if (typeof value === 'string' && value.length > 0 && normalized === '') {
                                    throw new Error('Vul een naam in.');
                                }
                                if (normalized !== '' && takenNames.includes(normalized)) {
                                    throw new Error('Er bestaat al een subledger met deze naam.');
                                }
                            },
                        },
                    ]}
                >
                    <Input type="text" autoComplete="off" placeholder="Bijv. Project Noord" />
                </Form.Item>
            </Form>
        </Popup>
    );
}
